import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const Modals = ({
    show,
    handleClose,
    title,
    textColor,
    children,
    size,
    centered,
    backdrop
}) => {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            size={size}
            centered={centered}
            backdrop={backdrop}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ color: textColor }}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    )
}

export default Modals